import { useEffect, useMemo, useState } from 'react'
import { Modal } from 'stories/components'
import { RenderInput } from 'utils/RenderInput'

import { msrLoanInputs } from './constants'
import { type IServicingMsrLoan, emptyServicingMsrLoan } from './types'

export const EditMsrLoanDialog = ({
  item,
  loanOptions,
  onClose,
  onSave,
}: {
  item: Partial<IServicingMsrLoan> | null
  loanOptions: Record<string, string>
  onClose: () => void
  onSave: (data: Partial<IServicingMsrLoan>) => Promise<void>
}) => {
  const [form, setForm] = useState<Partial<IServicingMsrLoan>>(emptyServicingMsrLoan())
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!item) return
    setForm({ ...item })
  }, [item])

  const inputs = useMemo(() => msrLoanInputs(form, loanOptions), [form, loanOptions])

  if (!item) return null

  const onChange = (key: string, value: any) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const onSubmit = async () => {
    setSaving(true)
    try {
      await onSave({
        loanId: form.loanId,
        upbServiced: Number(form.upbServiced || 0),
        capitalizedMsr: Number(form.capitalizedMsr || 0),
        accumAmort: Number(form.accumAmort || 0),
      })
      onClose()
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen
      title={item.id ? 'Edit MSR Loan' : 'Add MSR Loan'}
      loading={saving}
      disabled={!form.loanId?.trim()}
      onOk={onSubmit}
      onClose={onClose}
      titleOkay="Save"
      titleCancel=""
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        {Object.keys(inputs).map((key) => (
          <RenderInput key={key} input={inputs[key]} Key={key} onChange={onChange} />
        ))}
      </div>
    </Modal>
  )
}
